var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"danmu-standalone-page"},[_c('app-danmu-console',{attrs:{"show-backend-fullscreen":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }